import { render, staticRenderFns } from "./brandTendencyList.vue?vue&type=template&id=6eb3fc09&scoped=true&"
import script from "./brandTendencyList.vue?vue&type=script&lang=js&"
export * from "./brandTendencyList.vue?vue&type=script&lang=js&"
import style0 from "./brandTendencyList.vue?vue&type=style&index=0&id=6eb3fc09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb3fc09",
  null
  
)

export default component.exports